import React from 'react';
import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm, ITripToUk } from '../../../../../types';
import { SummaryGroup } from '../../../../Summary/SummaryGroup';
import { Box } from '@chakra-ui/react';
import { useTranslation } from "react-i18next";

function VisaPrepAdditionalHistoryStep3Info(props: IVisaPrepForm) {
    const { t } = useTranslation('forms.visa');
  const renderTripsToUk = () => {
    const allTripsToUK: React.ReactNode[] = [];
    if (props.tripsToUk && props.tripsToUk.length) {
      props.tripsToUk.forEach((ukTrip: ITripToUk, i: number) => {
        allTripsToUK.push(
          <SummaryGroup title={t('forms.visa:ukTrip', { i: i + 1 })} key={i}>
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.TRIPS_TO_UK_ARRIVAL_DATE}-${i}`}
              label={t('forms.visa:dateOfArrival')}
              value={ukTrip.arrivalDate}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.TRIPS_TO_UK_DEPARTURE_DATE}-${i}`}
              label={t('forms.visa:dateOfDeparture')}
              value={ukTrip.departureDate}
            />
            <SummaryRow
              className={'visa-summary'}
              key={VQ.TRIPS_TO_UK_PURPOSE}
              value={ukTrip.purpose}
              label={t('forms.visa:purposeOfTrip')}
            />
          </SummaryGroup>,
        );
      });
    }
    return allTripsToUK;
  };
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        label={t('forms.visa:howManyTripsDidYouTakeToTheUk')}
        value={props.tripsToUk?.length ?? 0}
      />

      <Box as="ol" pl={8}>
        {renderTripsToUk()}
      </Box>
    </>
  );
}

export default VisaPrepAdditionalHistoryStep3Info;
